import { render, staticRenderFns } from "./ServiceMaterialTable.vue?vue&type=template&id=26bb4279&scoped=true&"
import script from "./ServiceMaterialTable.vue?vue&type=script&lang=js&"
export * from "./ServiceMaterialTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bb4279",
  null
  
)

export default component.exports